import api from '@/utils/api'
import { buildListQuery } from '@/utils/listQuery'

export default {
    getLeagues(page, size) {
        let range = '?range=' + encodeURIComponent(`[${page - 1},${size}]`)
        return api.get(`leagues` + (page ? range : ''))
    },

    getFilteredLeagues(filter, page, size, sort) {
        return api.get(`leagues` + buildListQuery({ filter, page, size, sort }))
    },

    getLeague(id) {
        return api.get(`leagues/${id}`)
    },

    getAllActiveLeagues() {
        let query = '?filter=' + encodeURIComponent('{"active": true }')
        return api.get(`leagues` + query)
    },

    // the standings of a league in a season and phase (regular_season, playoffs, placements)
    getRanking(leagueId, seasonId, phase) {
        return api.get(`leagues/${leagueId}/season/${seasonId}/ranking` + (phase ? `?phase=${phase}` : ''))
    },

    getAllLeagues() {
        return api.get(`leagues/all`)
    },

    updateLeague(id, data) {
        return api.put(`leagues/${id}`, data)
    },

    createLeague(data) {
        return api.post('leagues', data)
    },

    deleteLeague(id) {
        return api.delete(`leagues/${id}`)
    }
}
